import React from 'react'

const CategoryDelete = () => {
  return (
    <div>CategoryDelete</div>
  )
}

export default CategoryDelete